import axios from 'axios'
import getConfig from 'next/config'
import PublicPageWrapper from 'components/wrappers/PublicPageWrapper'
import Head from 'next/head'
import { Chip, Typography } from '@mui/material'
import Image from 'next/image'
import introImage from '../../public/images/index/index-intro-graphic.png'
import styles from './blog.module.scss'
import Link from 'next/link'
import { KeyboardBackspaceOutlined } from '@mui/icons-material'

const { serverRuntimeConfig } = getConfig();

export default function BlogMain({ blogData }) {

  const posts = blogData.map((post, index) => {
    return (
      <article className={styles.listPost}>
        <div className={`${styles.postImage}`}>
          <img
            src={post.image}
            alt={post.title}
          />
        </div>
        <div className={styles.postContent}>
          <Link href={`/blog/${post.id}/${post.slug}`} passHref>
            <Typography variant='h2' className={styles.postTitle}>{post.title}</Typography>
          </Link>
          <div className={styles.postTags}>
            {post.tags.map((tag, tagIndex) => {
              return (
                <Chip label={tag} sx={{ mr: 1 }} />
              )
            })}
          </div>
          <Typography variant='body'><div dangerouslySetInnerHTML={{ __html: post.excerpt }} /></Typography>
          <Link href={`/blog/${post.id}/${post.slug}`}>
            <div className={styles.postCta}>
              <KeyboardBackspaceOutlined color='primary' sx={{ mr: 1 }} />
              <span>Continue reading</span>
            </div>
          </Link>
        </div>
      </article>
    )
  })

  return (
    <div>
      <Head>
        <title>Blog | MyTags</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <PublicPageWrapper>

        <div className={styles.container}>
          <section className={styles.intro}>
            <div className={styles.introContent}>
              <Typography variant='h1'>
                Blog
              </Typography>
              <Typography variant='subtitle1'>
                Read all about how you can utilise MyTags to improve your visitors' experiences, as well as some other useful content.
              </Typography>
            </div>
            <div className={styles.introDecoration}>
              <div className={styles.blobMask}>
                <Image
                  src={introImage}
                  alt='Blog'
                  layout='responsive'
                  sizes="(min-width: 75em) 33vw,
                      (min-width: 48em) 50vw,
                      100vw"
                />
              </div>
            </div>
          </section>
          <section className={styles.postsList}>
            {posts}
          </section>
        </div>

      </PublicPageWrapper>
    </div>
  )
}

export async function getServerSideProps({params}) {

  let blogData;

  try {
    blogData = await axios.get(`${serverRuntimeConfig.backendIsrHost}${serverRuntimeConfig.backendUrl}/api/blog/`);
  } catch (error) {
    console.error('Error:', error);
    console.log(`There was an issue with loading the Blog posts data.`);
    return {
      notFound: true,
    }
  }

  return {
    props: {
      blogData: blogData.data,
    },
  }
}
